export default __webpack_public_path__ + "static/media/services.e01a3c93.jpg";